import React from 'react';
import { ComposedChart, XAxis, YAxis, Tooltip, ResponsiveContainer, Bar } from 'recharts';
import { isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';
import { useTranslation } from 'react-i18next';

import styles from './styles/BillGraph.module.scss';

// Types.
import { GraphTooltipType } from '../../types/consumptionRates';
import { graphInvoices } from '../../types/billing';
// Utils.
import { formatDate, setPriceFormat, roundNumber } from '../../utils/billing';

const CustomTooltip: React.FunctionComponent<GraphTooltipType> = ({ active, payload }: GraphTooltipType) => {
  if (active && payload) {
    return (
      <div className="tooltip-lumme">
        <div className="tooltip-title">{payload[0].payload.name}</div>
        <div>
          <span>{payload[0].name}</span>
          <span>{setPriceFormat(roundNumber(payload[0].value)) ?? 0} €</span>
        </div>
      </div>
    );
  }
  return null;
};

const BillGraph: React.FunctionComponent<graphInvoices> = (props: graphInvoices) => {
  const { invoices, startDate, endDate } = props;
  const { t } = useTranslation();

  const billingData = [];

  // We are supplied newest -> oldest so we need to make the line in reverse order.
  const invoicesReversed = [...invoices].reverse();
  for (const invoice of invoicesReversed) {
    if (
      (isSameDay(startOfDay(new Date(invoice.dueDate)), startOfDay(startDate || new Date())) ||
        isAfter(startOfDay(new Date(invoice.dueDate)), startOfDay(startDate || new Date()))) &&
      (isSameDay(startOfDay(new Date(invoice.dueDate)), startOfDay(endDate || new Date())) ||
        isBefore(startOfDay(new Date(invoice.dueDate)), startOfDay(endDate || new Date())))
    ) {
      const point = {
        name: formatDate(invoice.dueDate),
        amountRet: invoice.totalWithVat,
      };
      billingData.push(point);
    }
  }

  return (
    <div className={styles.graph}>
      <ResponsiveContainer width={'100%'} height={400}>
        <ComposedChart data={billingData}>
          <XAxis dataKey="name" stroke="#000000" />
          <YAxis scale="linear" interval="preserveStartEnd" strokeWidth={0} stroke="#000000" />
          <Tooltip content={<CustomTooltip />} wrapperStyle={{ width: 300 }} />
          {billingData && <Bar name={`${t(`billing:graph.amountRet`)}`} dataKey="amountRet" fill="#c0e300" radius={[4, 4, 0, 0]} />}
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BillGraph;
